<script setup lang="ts">
// ================================
// IMPORTS
// ================================
// Vue
import { useI18n } from "vue-i18n"
import { ref } from "vue"

// Service
import { SourceService } from "@core/services"
const sourceService = new SourceService()

// ================================
// INTERNATIONALIZATION
// ================================
const { t } = useI18n({
    messages: {
        fr: {
            title: "Êtes-vous sûr de vouloir supprimer cette note",
            button_delete: "Oui, Supprimer la note",
            button_quit: "Non, garder la note",
        },
    },
})

// ================================
// TYPES & INTERFACES
// ================================

const emit = defineEmits(["update"])
const loading = ref(false)

// ================================
// PROPS & EMITS
// ================================
type Props = {
    meterId: string
    noteId: string | undefined
}
const props = defineProps<Props>()

const [visible] = defineModel<boolean>("visible", {
    required: true,
    default: false,
})

const onConfirmDelete = async () => {
    loading.value = true
    await sourceService.deleteNoteBySourceIdAndNoteId(
        props.meterId,
        props.noteId!
    )
    emit("update")
    loading.value = false
    visible.value = false
}
</script>

<template>
    <BaseDialog
        v-model:visible="visible"
        modal
        :closable="true"
        dismissable-mask
        class="modal-meter-edit-notes max-w-[35rem] w-full"
        :header="t('title')"
        :pt="{
            header: 'flex-col-reverse p-0!',
            headeractions: 'ml-auto',
            title: 'text-primary mb-4',
        }"
    >
        <template #footer>
            <div class="flex gap-2 w-full justify-between">
                <BaseButton
                    @click="visible = false"
                    :label="t('button_quit')"
                    severity="secondary"
                    text
                />
                <BaseButton
                    @click="onConfirmDelete"
                    :label="t('button_delete')"
                    severity="danger"
                    icon="pi pi-trash"
                    autofocus
                    :loading="loading"
                />
            </div>
        </template>
    </BaseDialog>
</template>

<style scoped></style>
